import { Form, Input } from 'antd';
import CustomInputLabel from 'components/Label/CustomInputLabel';

const CustomTextareaInput = ({
	form,
	label,
	head,
	name,
	rules,
	value,
	size = 'default',
	count,
	disabled,
	autocomplete = 'off',
	placeholder = 'Write here',
	style,
	autoSize,
	...rest
}) => {
	return (
		<Form.Item name={name} label={label} rules={rules} style={style}>
			{/* {disabled ? (
				<CustomInputLabel head={head} label={form?.getFieldValue(name) ?? (value ? value : '')} sx={{ ...style }} />
			) : ( */}
			<Input.TextArea
				name={name}
				count={count}
				size={size}
				placeholder={placeholder}
				autocomplete={autocomplete}
				autoSize={autoSize ?? { minRows: 3, maxRows: 5 }}
				style={{ height: '32px', borderRadius: '4px', ...style, fontSize: '13px' }}
				{...rest}
			/>
			{/* )} */}
		</Form.Item>
	);
};

export default CustomTextareaInput;
